import GrowthHeroText from "./GrowthHeroText";
import GrowthHeroGrid from "./GrowthHeroGrid";
import BorderDrawer from "./BorderDrawer";
import GrowthTeamItem from "./GrowthTeamItem";
import GrowthTilesItem from "./GrowthTilesItem";
import GrowthLatest from "./GrowthLatest";

class VerticalGrowth {
    constructor() {
        this.init();
    }

    init() {
        this.heroTextRotatorEl = document.querySelector('.gl-hero .animated-words');
        if(this.heroTextRotatorEl) {
            this.growthHeroText = new GrowthHeroText(this.heroTextRotatorEl);
        }

        this.heroGridAminatedEl = document.querySelector('.gl-hero .animated-grid');
        if(this.heroGridAminatedEl) {
            this.growthHeroGrid = new GrowthHeroGrid(this.heroGridAminatedEl);
        }

        this.borderDrawEls = document.querySelectorAll('.gl-border-draw');
        if(this.borderDrawEls.length) {
            this.borderDrawEls.forEach(borderDrawEl => {
                const hideDrawBottom = borderDrawEl.classList.contains('gl-border-hide-bottom');
                new BorderDrawer(borderDrawEl, 50, hideDrawBottom);
            });
        }

        this.growthTeamItemEls = document.querySelectorAll('.member');
        if(this.growthTeamItemEls.length) {
            this.growthTeamItemEls.forEach(growthTeamItemEl => {
                new GrowthTeamItem(growthTeamItemEl);
            });
        }

        this.growthTilesItemEls = document.querySelectorAll('.gl-tiles-container .tile');
        if(this.growthTilesItemEls.length) {
            this.growthTilesItemEls.forEach(growthTilesItemEl => {
                new GrowthTilesItem(growthTilesItemEl);
            });
        }

        this.glLatestFromGrowthEl = document.querySelector('.gl-latest-from-growth');
        if(this.glLatestFromGrowthEl) {
            new GrowthLatest(this.glLatestFromGrowthEl);
        }
    }
}

export default VerticalGrowth
